module.exports = __webpack_public_path__ + "img/folder-arrow-up.5ba824c8.svg";